import { render, staticRenderFns } from "./r-currency-kind-page.vue?vue&type=template&id=af73533e&scoped=true&class=currency-kind-page"
import script from "./r-currency-kind-page.vue?vue&type=script&lang=js"
export * from "./r-currency-kind-page.vue?vue&type=script&lang=js"
import style0 from "./r-currency-kind-page.vue?vue&type=style&index=0&id=af73533e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af73533e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af73533e')) {
      api.createRecord('af73533e', component.options)
    } else {
      api.reload('af73533e', component.options)
    }
    module.hot.accept("./r-currency-kind-page.vue?vue&type=template&id=af73533e&scoped=true&class=currency-kind-page", function () {
      api.rerender('af73533e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency-kind/r-currency-kind-page.vue"
export default component.exports